import Http from "./base-http";

class Task extends Http {
  deleteTask(id) {
    return this.destroy(id);
  }
  addTask(variables) {
    return this.create(variables);
  }
}
const taskObj = new Task({
  modelUrlPrefix : "Task"
});
export default taskObj;
